// Set to true to re-enable every form that submits to the backend
// (applications, survey and contact form) once the backend is back.
export const FORMS_ENABLED = false;

export const FORM_LINK_UNAVAILABLE_NOTE = "Temporarily unavailable";

export const FORM_PAGE_UNAVAILABLE_MESSAGE =
  "Online applications are temporarily unavailable while we make some updates. Please check back soon.";

export const CONTACT_FORM_UNAVAILABLE_MESSAGE =
  "Our contact form is currently unavailable.";
